import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// ✅ Interface correta para a resposta do backend
export interface SchedulerStatusResponse {
  success: boolean;
  ativo: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  constructor(private http: HttpClient) {}

  /**
   * Verifica se um job está ativo no scheduler
   * @param jobId ID do job a ser verificado
   * @returns Observable com o status ativo/inativo
   */
  isJobAtivo(jobId: string): Observable<boolean> {
    return this.http.get<SchedulerStatusResponse>(`api/v2/scheduler`, {
      params: { id: jobId }
    }).pipe(
      map((response: SchedulerStatusResponse) => {
        // Se a requisição falhou ou não retornou success, retorna false
        if (!response || !response.success) {
          return false;
        }
        // Retorna o valor de ativo
        return response.ativo === true;
      })
    );
  }

  /**
   * Verifica se o job de relatórios avançados está ativo
   * @returns Observable com o status do job
   */
  isRelatoriosAvancadosAtivo(): Observable<boolean> {
    return this.isJobAtivo('relatorios-avancados');
  }
}
